import 'react-app-polyfill/stable';
import TagManager from 'react-gtm-module';
import React from 'react';
import ReactDOM from 'react-dom';
import { registerObserver } from 'react-perf-devtool';

import './index.scss';
import Root from 'views/Root/Root';
import './i18n'; 

const GTM_KEY = process.env.REACT_APP_GTM;
registerObserver();
const tagManagerArgs = {
  gtmId: GTM_KEY,
  dataLayerUpsellSummary: 'UpsellSummary',
  dataLayerDiets: 'dataLayerDiets',
};
if (GTM_KEY) {
  TagManager.initialize(tagManagerArgs);
}

ReactDOM.render(<Root />, document.getElementById('root'));

if ('serviceWorker' in navigator) {
  if (typeof navigator.serviceWorker.getRegistrations === 'function') {
    navigator.serviceWorker
      .getRegistrations()
      .then((regs) => Promise.all(regs.map((r) => r.unregister())))
      .catch(() => {})
      .finally(() => {
        if (window.caches && typeof caches.keys === 'function') {
          caches.keys().then((keys) => {
            keys.forEach((k) => caches.delete(k));
          });
        }
      });
  }
}

